<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/5_Itinerari-esperienze/5a_cammini-outdoor-Archiforo.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Cammini Outdoor</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Esperienze e itinerari</a> > <a class="active">Cammini Outdoor</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Con i suoi 350.000 mila ettari di natura protetta la Calabria è il paradiso del trekking e delle attività outdoor. 
            In primo piano, troviamo il Sentiero Italia che attraversa l’intera regione per ben 654 Km offrendo paesaggi splendidi che variano dai boschi 
            fitti e dalle foreste delle aree Parco ai declivi che affacciano sulle coste dello Jonio e del Tirreno. Tra i percorsi religiosi, invece, 
            si segnalano: il Cammino di San Francesco da Paola, che va da San Marco Argentano a Paterno Calabro e poi discende verso Corigliano Calabro 
            seguendo la Via dei Monasteri, per un totale di 247 Km; il Cammino di Gioacchino da Fiore che attraversa il Parco della Sila da San Giovanni in 
            Fiore e procede fino alle suggestive rovine dell’Abbazia di Corazzo (60 Km); il Cammino Basiliano che percorre l’intera Calabria da nord a sud con 
            i suoi circa 1000 Km tra abbazie, conventi, chiese, da Rocca Imperiale a Reggio Calabria.
            <br>
            <br>
            A questi itinerari si aggiungono il Sentiero del Brigante, che attraversa l’Aspromonte e le Serre una delle aree più belle e meno frequentate 
            dell’Appennino meridionale, da Gambarie a Serra San Bruno fino a Stilo, e il Sentiero dell’Inglese, percorso affascinante nel cuore dell’area grecanica 
            all’estremo sud della Calabria, ispirato al viaggio ottocentesco dello scrittore e pittore inglese Edward Lear, da Pentedattilo a Palizzi. Si tratta di 
            itinerari per la maggior parte percorribili anche a cavallo o in sella a una Mountain Bike.
            <br>
            <br>
            Oltre ai sentieri per il trekking sono molte altre le attività outdoor che la Calabria offre: quelle dei Parchi avventura che sono presenti 
            in tutte le aree protette, il canyoning e il rafting sul fiume Lao nel Pollino; lo sci di fondo che si può praticare in tutte le aree Parco, 
            ma vi sono anche piste per la discesa molto ben attrezzate come quelle di Lorica e Camigliatello in Sila e quelle di Gambarie d’Aspromonte da cui 
            si gode una vista mozzafiato sullo Stretto. Tanti sono poi i Circoli nautici che offrono la possibilità di solcare il Mediterraneo in barca a vela o in canoa, 
            inteso che gli oltre 800 Km di costa della Calabria offrono a tutti gli appassionati degli sport d’acqua spazio per ogni genere di attività.
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>